import { useMemo, type ReactNode } from 'react';

import { RendererLabelsProvider } from '@/lib/article-renderer/core/labels';
import { useT } from '@shared/i18n';

/**
 * Hands the article renderer its own labels ("Content unavailable", the
 * offline-embed notice...) in the app language. The renderer is a
 * standalone library with English defaults and no i18n of its own
 * (src/lib/article-renderer/core/labels.tsx); mounted once, in app/app.tsx.
 */
export function AppRendererLabels({ children }: { children: ReactNode }) {
	const t = useT();
	const labels = useMemo(
		() => ({
			contentUnavailable: t('renderer.contentUnavailable'),
			video: t('renderer.video'),
			brightcoveVideo: t('renderer.brightcoveVideo'),
			soundcloudAudio: t('renderer.soundcloudAudio'),
			videoUnsupported: t('renderer.videoUnsupported'),
			embedOffline: (platform: string) => t('renderer.embedOffline', { platform }),
			embedOfflineRetry: t('renderer.embedOfflineRetry'),
			embedFailed: (platform: string) => t('renderer.embedFailed', { platform }),
			twitterTimeline: (screenName: string) =>
				t('renderer.twitterTimeline', { screenName }),
		}),
		[t],
	);
	return <RendererLabelsProvider labels={labels}>{children}</RendererLabelsProvider>;
}
